/**
 * Created by maqyf on 2022/10/18.
 */
import NCCreateSearch from './createSearch';

/*
*   @ 简洁查询区交互说明：
*   1、根据appcode和pagecode获取查询区模板
*   2、默认隐藏高级查询及其它按钮，只展示查询条件
* */
export default function NCCreateSimpleSearch(
    moduleId,
    {
        //传入pagecode和appcode加载查询区模板
        appCode, //应用编码
        pageCode, //页面编码
        //展示形态类的配置
        showAdvBtn = false, // 是否显示高级查询按钮和查询方案按钮 ,默认不显示 ---
        //显示隐藏配置
        hideBtnArea = true, // 隐藏查询按钮区域，默认true ---
        ...otherProps
    } = {},
) {
    this.createUIDom(
        {
            pagecode: pageCode,
            appcode: appCode,
        },
        data => {
            if(data.template && data.template[moduleId]){
                this.meta.setMeta(data.template);
            }
        },
    );
    
    return NCCreateSearch.call(this, moduleId, {
        showAdvBtn,
        hideBtnArea,
        ...otherProps,
    });
}
